<h1 mat-dialog-title class="mat-dialog-title">{{ context.title }}</h1>

<div mat-dialog-content class="mat-dialog-content">
  <p>{{ context?.message }}</p>
</div>
<div mat-dialog-actions align="end">
  @if (!context.hideCancelBtn) {
    <button mat-raised-button (click)="onCancel()">Cancel</button>
  }
  <button mat-raised-button (click)="onConfirm()" class="button" color="primary">
    {{ context.confirmBtnText ? context.confirmBtnText : 'OK' }}
  </button>
</div>
